import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'

import { Button, Flex, H5, P } from 'ui/bend'

const getSourceProps = (source) => {
  switch (source) {
    case 'ios': {
      return {
        text: 'iTunes',
        cta: 'Apple',
        href: 'https://support.apple.com/en-us/HT202039'
      }
    }
    default: {
      return {
        text: 'N/A',
        cta: 'N/A',
        href: 'https://alomoves.com'
      }
    }
  }
}

const RenewNonStripe = ({ source }) => {
  const { colors } = useTheme()

  const { cta, href, text } = getSourceProps(source)

  return (
    <Flex flexDirection='column' alignItems='center'>
      <H5 color='primary' textAlign='center'>
        Your Membership is maintained through {text}
      </H5>
      <P>Please go there to manage your account.</P>
      <Button
        as='a'
        className='unstyled'
        style={{ color: colors.base }}
        href={href}
        target='_blank'
        rel='noreferrer'
      >
        Manage {cta} Subscriptions
      </Button>
    </Flex>
  )
}

RenewNonStripe.propTypes = {
  source: PropTypes.string.isRequired
}

export default RenewNonStripe
